module.exports = __webpack_public_path__ + "img/phone-sms-configuration.35111a0b.png";